import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import { INTERACTION_SEVERITY_META } from '../../lib/interactionCheck';

const InteractionWarningModal = ({
  warnings = [],
  subjectName = '',
  acknowledgeLabel = 'Prescribe anyway',
  onCancel,
  onAcknowledge,
}) => {
  const show = warnings.length > 0;
  const intro = subjectName
    ? `Prescribing ${subjectName} raises the following warning${warnings.length === 1 ? '' : 's'}:`
    : `This prescription set raises the following warning${warnings.length === 1 ? '' : 's'}:`;

  return (
    <Modal show={show} onHide={onCancel} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Prescribing warning</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">{intro}</p>
        <ListGroup variant="flush" className="mb-3">
          {warnings.map((hit) => {
            const meta = INTERACTION_SEVERITY_META[hit.severity] || INTERACTION_SEVERITY_META.moderate;
            const isDuplicate = hit.kind === 'duplicate';
            return (
              <ListGroup.Item key={hit.id} className="px-0">
                <div className="d-flex justify-content-between align-items-start gap-2">
                  <div className="fw-semibold">
                    {isDuplicate ? `Duplicate: ${hit.drugAName}` : `${hit.drugAName} + ${hit.drugBName}`}
                  </div>
                  <Badge
                    bg={isDuplicate ? 'danger' : meta.bg}
                    text={!isDuplicate && meta.bg === 'warning' ? 'dark' : undefined}
                  >
                    {isDuplicate ? 'Duplicate' : meta.label}
                  </Badge>
                </div>
                {hit.note ? (
                  <div className="small text-muted mt-1" style={{ whiteSpace: 'pre-wrap' }}>{hit.note}</div>
                ) : null}
              </ListGroup.Item>
            );
          })}
        </ListGroup>
        <Alert variant="warning" className="mb-0">
          Confirm you have considered the clinical risk before proceeding.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" onClick={onAcknowledge}>{acknowledgeLabel}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InteractionWarningModal;
